import { PipeTransform, Pipe } from "@angular/core";

/* 
  Pipe for highlighting matching text 

  Note: - The matching text is appended into innerHTML and can be styled using any custom class. 'highlight' in this case.

  Also see : - https://gist.github.com/adamrecsko/0f28f474eca63e0279455476cc11eca7

*/

@Pipe({ name: "highlight" })
export class HighlightSearch implements PipeTransform {
  transform(text: string, search: string): string {
    let pattern = search.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, "\\$&");
    pattern = pattern
      .split(" ")
      .filter((t) => {
        return t.length > 0;
      })
      .join("|");
    const regex = new RegExp(pattern, "gi");

    return search
      ? text.replace(
          regex,
          (match) => `<span class="highlight">${match}</span>`
        )
      : text;
  }
}
